import { render, staticRenderFns } from "./AppointmentBox.vue?vue&type=template&id=4db2a061&scoped=true"
import script from "./AppointmentBox.vue?vue&type=script&lang=js"
export * from "./AppointmentBox.vue?vue&type=script&lang=js"
import style0 from "./AppointmentBox.vue?vue&type=style&index=0&id=4db2a061&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db2a061",
  null
  
)

export default component.exports